import { v4 as uuidv4 } from "uuid";
import type { AreaRow } from "./types";

export function areaElementToRow(el: any): AreaRow {
  const config = el?.elementConfig?.config || {};
  const polygon = config.polygon || {};
  return {
    id: el?.id ?? uuidv4(),
    elementId: el?.id,
    titulo: el?.titulo ?? "",
    color: polygon.color ?? "",
    fillColor: polygon.fillColor ?? "",
    font: el?.font ?? null,
    tags: Array.isArray(el?.tags) ? el.tags : [],
    img: el?.img ?? null,
    mapRefId: el?.mapRefId ?? el?.mapRef?.id ?? null,
    _origConfig: config,
    _errors: {},
  };
}
